const cleanNumber = (number) => {
	return (number || '').replace(/\D+/g, '')
}

const formatE164 = (number) => {
	if (number.match(/^0([1-9]\d{8,9})$/)) return `44${number.substring(1)}`
	if (number.match(/^(00)?44([1-9]\d{8,9})$/)) return `44${number.match(/^(00)?44([1-9]\d{8,9})$/)[2]}`
	if (number.match(/^\+?(00)?([1-9]\d{6,16})$/)) return number.match(/^\+?(00)?([1-9]\d{6,16})$/)[2]
	else return number
}

const formatE164Plus = (number) => {
	if (number.match(/^0([1-9]\d{8,9})$/)) return `+44${number.substring(1)}`
	if (number.match(/^(00)?44([1-9]\d{8,9})$/)) return `+44${number.match(/^(00)?44([1-9]\d{8,9})$/)[2]}`
	if (number.match(/^\+?(00)?([1-9]\d{6,16})$/)) return `+${number.match(/^\+?(00)?([1-9]\d{6,16})$/)[2]}`
	else return number
}

const formatDomestic = (number) => {
	if (number.match(/^0([1-9]\d{8,9})$/)) return `0${number.substring(1)}`
	if (number.match(/^(00)?44([1-9]\d{8,9})$/)) return `0${number.match(/^(00)?44([1-9]\d{8,9})$/)[2]}`
	if (number.match(/^\+?(00)?([1-9]\d{6,16})$/)) return `00${number.match(/^\+?(00)?([1-9]\d{6,16})$/)[2]}`
	else return number
}

const formatE164With00 = (number) => {
	if (number.match(/^0([1-9]\d{8,9})$/)) return `44${number.substring(1)}`
	if (number.match(/^(00)?44([1-9]\d{8,9})$/)) return `44${number.match(/^(00)?44([1-9]\d{8,9})$/)[2]}`
	if (number.match(/^\+?(00)?([1-9]\d{6,16})$/)) return `00${number.match(/^\+?(00)?([1-9]\d{6,16})$/)[2]}`
	else return number
}

const formatNational = (number) => {
	if (number.match(/^0([1-9]\d{8,9})$/)) return `${number.substring(1)}`
	if (number.match(/^(00)?44([1-9]\d{8,9})$/)) return `${number.match(/^(00)?44([1-9]\d{8,9})$/)[2]}`
	if (number.match(/^\+?(00)?([1-9]\d{6,16})$/)) return `0${number.match(/^\+?(00)?([1-9]\d{6,16})$/)[2]}`
	else return number
}

const formatNoPrefix = (number) => {
	if (number.startsWith('0044')) return number.substring(4)
	if (number.startsWith('00')) return number.substring(2)
	if (number.startsWith('44')) return number.substring(2)
	if (number.startsWith('0')) return number.substring(1)
	return number
}

module.exports = (number, format) => {
	number = cleanNumber(number)

	switch (format) {
		case 'E164':
			return formatE164(number)
		case 'E164+':
			return formatE164Plus(number)
		case 'E164_00':
			return formatE164With00(number)
		case 'DOMESTIC':
			return formatDomestic(number)
		case 'NATIONAL':
			return formatNational(number)
		case 'NO_PREFIX':
			return formatNoPrefix(number)
		default:
			return number
	}
}
